const Close = () => {
  return (
    <svg viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1927 16.9706L2.22217 0L0.807954 1.41421L17.7785 18.3848L19.1927 16.9706Z"
        fill="currentColor"
      />
      <path
        d="M0.807758 16.9706L17.7783 0L19.1925 1.41421L2.22197 18.3848L0.807758 16.9706Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Close;
